import quickActionsService from '../services/quickActionsService'

const state = {
  actions: null
};

const mutations = {
  setActions(state, actions) {
    state.actions = actions
  }
}

const actions = {
  async loadActions({commit}) {
    const actions = await quickActionsService.get()
    commit('setActions', actions)
  }
}

const getters = {
  permissionsConfig: (state, getters, rootState, rootGetters) => {
    const hasPermission = rootGetters['accountModule/hasPermission']

    return {
      appointment: true,
      client: true,
      message: true,
      portal: true,
      schedule: true,
      register_to_event: true,
      invoice: hasPermission('can_view_payments'),
      record_payment: hasPermission('can_view_payments'),
      accept_payment: hasPermission('can_view_payments'),
      pay: hasPermission('can_view_payments'),
      schedule_payment: hasPermission('can_view_payments'),
      document: hasPermission('can_view_documents'),
      share_document: hasPermission('can_view_documents'),
      internal_document: hasPermission('can_view_documents'),
      request_signature: hasPermission('can_view_documents'),
      estimate: hasPermission('can_view_payments'),
      announcement: rootGetters['accountModule/hasAccessToSettings']
    }
  },
  pick: (state, getters) => (actions) => {
    if (!state.actions) return []

    const permissionsConfig = getters.permissionsConfig
    const myArray = new Array(actions.length)
    actions
      .map(item => ({...state.actions[item], action: item}))
      .forEach(item => myArray[item.order] = item.action)

    return myArray.filter(item => !!item && permissionsConfig[item])
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
